/**
 * User Slice
 * Redux slice for user context state management
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { User } from '@/types/shared/auth.types'

interface UserState {
  user: User | null
  isLoading: boolean
  error: string | null
}

const initialState: UserState = {
  user: null,
  isLoading: false,
  error: null,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload
    },
    updateUser: (state, action: PayloadAction<Partial<User>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload }
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    clearUser: (state) => {
      state.user = null
      state.error = null
    },
  },
})

export const {
  setUser,
  updateUser,
  setLoading,
  setError,
  clearUser,
} = userSlice.actions

export default userSlice.reducer

